import { FormattedMessage } from 'react-intl';

import { StartRentalButtonScreenshot } from '../1-1-0/StartRentalButtonScreenshot';
import { VATBasedRentalDialogScreenshot } from './VATBasedRentalDialogScreenshot';

export const VATBasedRental = () => (
    <div className='max-width-800'>
        <p>
            <FormattedMessage id='intl-msg:rental-web.serviceInfo.VATBasedRental.step1' />
        </p>
        <StartRentalButtonScreenshot />
        <p>
            <FormattedMessage id='intl-msg:rental-web.serviceInfo.VATBasedRental.step2' />
        </p>
        <VATBasedRentalDialogScreenshot />
        <p>
            <FormattedMessage id='intl-msg:rental-web.serviceInfo.VATBasedRental.step3' />
        </p>
        <p>
            <FormattedMessage id='intl-msg:rental-web.serviceInfo.VATBasedRental.step4' />
        </p>
    </div>
);
